module.exports = __webpack_public_path__ + "img/68700cf.jpg";